import { useNavigate, useSearchParams } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import Search from "../component/Search/Search.js";
import SearchResultsList from "../component/Search/SearchResultsList.js";

export default function SearchResults() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlQuery = searchParams.get("q") || "";
  const [input, setInput] = useState(urlQuery);

  // keep the input in sync if user navigates back/forward
  useEffect(() => {
    setInput(urlQuery);
  }, [urlQuery]);

  // on first mount, default to last search if present
  useEffect(() => {
    if (!urlQuery) {
      const storedHistory = JSON.parse(localStorage.getItem("searchHistory") || "[]");
      const lastSearch = storedHistory[0] || ""; // evita di passare un array
      setSearchParams({ q: lastSearch, page: "1" });
    }
  }, []); // intenzionale: solo al mount

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearchParams({ q: input, page: "1" });
  };

  return (
    <div className="flex h-screen overflow-hidden"> 
      {/* Sidebar SINISTRA: larghezza fissa, resta visibile */}
      <aside className="w-80 xl:w-96 shrink-0 border-r border-neutral-800 bg-black/20">
        <div className="sticky top-0 h-screen overflow-y-auto p-5">
          <Search />
        </div>
      </aside>

      {/* Contenuto DESTRA: scrolla verticalmente */}
      <main className="flex-1 overflow-y-auto">
        <div className="p-5">
          {urlQuery.trim().length > 0 ? (
            <SearchResultsList query={urlQuery} />
          ) : (
            <p className="text-gray-500 text-2xl md:text-3xl p-10">
              Cerca sulla tua sinistra per vedere un video
            </p>
          )}
        </div>
      </main>
    </div>
  );
}
